const asset_types = [
	'Video',
	'Dubcard',
	'Audio',
	'Subtitle'
]

const asset_roles = [
	'Feature',
	'Trailer'
]

const audio_types = [
	'primary',
	'narration',
	'dialog centric',
	'commentary'
]

const ReleaseType = [
	'original',
	'Broadcast',
	'DVD',
	'Blu-ray',
	'Hospitality',
	'PayTV',
	'InternetBuy',
	'InternetRent',
	'Theatrical',
	'VOD',
	'AVOD',
	'PVOD',
	'SVOD'
]

const PictureColorType = [
	{ value: 'color', text: 'color' },
	{ value: 'bandw', text: 'black and white' },
	{ value: 'colorized', text: 'colorized' },
	{ value: 'composite', text: 'color composite (ex: Sin City)' },
	{ value: 'unknown', text: 'unknown' }
]

const genres = [
	`Action`,
	`Adult`,
	`Adventure`,
	`Anime`,
	`Animation`,
	`Children’s`,
	`Comedy`,
	`Documentary`,
	`Drama`,
	`Education`,
	`Erotic`,
	`Faith and Spirituality`,
	`Family`,
	`Fantasy`,
	`Food`,
	`Horror`,
	`Independent`,
	`Instructional`,
	`Live Performance`,
	`Music Performance`,
	`Musical`,
	`Mystery`,
	`Reality`,
	`Romance`,
	`Science Fiction`,
	`Sports`,
	`Thriller`,
	`Variety/Talk Show`,
	`Western`,
	`Miscellaneous`
]

const countries = [
	{ text: 'Afghanistan', code: 'AF' },
	{ text: 'Afrique du Sud', code: 'ZA' },
	{ text: 'Îles Åland', code: 'AX' },
	{ text: 'Albanie', code: 'AL' },
	{ text: 'Algérie', code: 'DZ' },
	{ text: 'Allemagne', code: 'DE' },
	{ text: 'Andorre', code: 'AD' },
	{ text: 'Angola', code: 'AO' },
	{ text: 'Anguilla', code: 'AI' },
	{ text: 'Antarctique', code: 'AQ' },
	{ text: 'Antigua-et-Barbuda', code: 'AG' },
	{ text: 'Arabie saoudite', code: 'SA' },
	{ text: 'Argentine', code: 'AR' },
	{ text: 'Arménie', code: 'AM' },
	{ text: 'Aruba', code: 'AW' },
	{ text: 'Australie', code: 'AU' },
	{ text: 'Autriche', code: 'AT' },
	{ text: 'Azerbaïdjan', code: 'AZ' },
	{ text: 'Bahamas', code: 'BS' },
	{ text: 'Bahreïn', code: 'BH' },
	{ text: 'Bangladesh', code: 'BD' },
	{ text: 'Barbade', code: 'BB' },
	{ text: 'Biélorussie', code: 'BY' },
	{ text: 'Belgique', code: 'BE' },
	{ text: 'Belize', code: 'BZ' },
	{ text: 'Bénin', code: 'BJ' },
	{ text: 'Bermudes', code: 'BM' },
	{ text: 'Bhoutan', code: 'BT' },
	{ text: 'Bolivie', code: 'BO' },
	{ text: 'Pays-Bas caribéens', code: 'BQ' },
	{ text: 'Bosnie-Herzégovine', code: 'BA' },
	{ text: 'Botswana', code: 'BW' },
	{ text: 'Île Bouvet', code: 'BV' },
	{ text: 'Brésil', code: 'BR' },
	{ text: 'Brunei', code: 'BN' },
	{ text: 'Bulgarie', code: 'BG' },
	{ text: 'Burkina Faso', code: 'BF' },
	{ text: 'Burundi', code: 'BI' },
	{ text: 'Îles Caïmans', code: 'KY' },
	{ text: 'Cambodge', code: 'KH' },
	{ text: 'Cameroun', code: 'CM' },
	{ text: 'Canada', code: 'CA' },
	{ text: 'Cap-Vert', code: 'CV' },
	{ text: 'République centrafricaine', code: 'CF' },
	{ text: 'Chili', code: 'CL' },
	{ text: 'Chine', code: 'CN' },
	{ text: 'Île Christmas', code: 'CX' },
	{ text: 'Chypre (pays)', code: 'CY' },
	{ text: 'Îles Cocos', code: 'CC' },
	{ text: 'Colombie', code: 'CO' },
	{ text: 'Comores (pays)', code: 'KM' },
	{ text: 'République du Congo', code: 'CG' },
	{ text: 'République démocratique du Congo', code: 'CD' },
	{ text: 'Îles Cook', code: 'CK' },
	{ text: 'Corée du Sud', code: 'KR' },
	{ text: 'Corée du Nord', code: 'KP' },
	{ text: 'Costa Rica', code: 'CR' },
	{ text: 'Côte d\'Ivoire', code: 'CI' },
	{ text: 'Croatie', code: 'HR' },
	{ text: 'Cuba', code: 'CU' },
	{ text: 'Curaçao', code: 'CW' },
	{ text: 'Danemark', code: 'DK' },
	{ text: 'Djibouti', code: 'DJ' },
	{ text: 'République dominicaine', code: 'DO' },
	{ text: 'Dominique', code: 'DM' },
	{ text: 'Égypte', code: 'EG' },
	{ text: 'Salvador', code: 'SV' },
	{ text: 'Émirats arabes unis', code: 'AE' },
	{ text: 'Équateur (pays)', code: 'EC' },
	{ text: 'Érythrée', code: 'ER' },
	{ text: 'Espagne', code: 'ES' },
	{ text: 'Estonie', code: 'EE' },
	{ text: 'États-Unis', code: 'US' },
	{ text: 'Éthiopie', code: 'ET' },
	{ text: 'Malouines', code: 'FK' },
	{ text: 'Îles Féroé', code: 'FO' },
	{ text: 'Fidji', code: 'FJ' },
	{ text: 'Finlande', code: 'FI' },
	{ text: 'France', code: 'FR' },
	{ text: 'Gabon', code: 'GA' },
	{ text: 'Gambie', code: 'GM' },
	{ text: 'Géorgie (pays)', code: 'GE' },
	{ text: 'Géorgie du Sud-et-les îles Sandwich du Sud', code: 'GS' },
	{ text: 'Ghana', code: 'GH' },
	{ text: 'Gibraltar', code: 'GI' },
	{ text: 'Grèce', code: 'GR' },
	{ text: 'Grenade (pays)', code: 'GD' },
	{ text: 'Groenland', code: 'GL' },
	{ text: 'Guadeloupe', code: 'GP' },
	{ text: 'Guam', code: 'GU' },
	{ text: 'Guatemala', code: 'GT' },
	{ text: 'Guernesey', code: 'GG' },
	{ text: 'Guinée', code: 'GN' },
	{ text: 'Guinée-Bissau', code: 'GW' },
	{ text: 'Guinée équatoriale', code: 'GQ' },
	{ text: 'Guyana', code: 'GY' },
	{ text: 'Guyane', code: 'GF' },
	{ text: 'Haïti', code: 'HT' },
	{ text: 'Îles Heard-et-MacDonald', code: 'HM' },
	{ text: 'Honduras', code: 'HN' },
	{ text: 'Hong Kong', code: 'HK' },
	{ text: 'Hongrie', code: 'HU' },
	{ text: 'Île de Man', code: 'IM' },
	{ text: 'Îles mineures éloignées des États-Unis', code: 'UM' },
	{ text: 'Îles Vierges britanniques', code: 'VG' },
	{ text: 'Îles Vierges des États-Unis', code: 'VI' },
	{ text: 'Inde', code: 'IN' },
	{ text: 'Indonésie', code: 'ID' },
	{ text: 'Iran', code: 'IR' },
	{ text: 'Irak', code: 'IQ' },
	{ text: 'Irlande (pays)', code: 'IE' },
	{ text: 'Islande', code: 'IS' },
	{ text: 'Israël', code: 'IL' },
	{ text: 'Italie', code: 'IT' },
	{ text: 'Jamaïque', code: 'JM' },
	{ text: 'Japon', code: 'JP' },
	{ text: 'Jersey', code: 'JE' },
	{ text: 'Jordanie', code: 'JO' },
	{ text: 'Kazakhstan', code: 'KZ' },
	{ text: 'Kenya', code: 'KE' },
	{ text: 'Kirghizistan', code: 'KG' },
	{ text: 'Kiribati', code: 'KI' },
	{ text: 'Koweït', code: 'KW' },
	{ text: 'Laos', code: 'LA' },
	{ text: 'Lesotho', code: 'LS' },
	{ text: 'Lettonie', code: 'LV' },
	{ text: 'Liban', code: 'LB' },
	{ text: 'Liberia', code: 'LR' },
	{ text: 'Libye', code: 'LY' },
	{ text: 'Liechtenstein', code: 'LI' },
	{ text: 'Lituanie', code: 'LT' },
	{ text: 'Luxembourg (pays)', code: 'LU' },
	{ text: 'Macao', code: 'MO' },
	{ text: 'Macédoine du Nord', code: 'MK' },
	{ text: 'Madagascar', code: 'MG' },
	{ text: 'Malaisie', code: 'MY' },
	{ text: 'Malawi', code: 'MW' },
	{ text: 'Maldives', code: 'MV' },
	{ text: 'Mali', code: 'ML' },
	{ text: 'Malte', code: 'MT' },
	{ text: 'Îles Mariannes du Nord', code: 'MP' },
	{ text: 'Maroc', code: 'MA' },
	{ text: 'Îles Marshall (pays)', code: 'MH' },
	{ text: 'Martinique', code: 'MQ' },
	{ text: 'Maurice (pays)', code: 'MU' },
	{ text: 'Mauritanie', code: 'MR' },
	{ text: 'Mayotte', code: 'YT' },
	{ text: 'Mexique', code: 'MX' },
	{ text: 'États fédérés de Micronésie (pays)', code: 'FM' },
	{ text: 'Moldavie', code: 'MD' },
	{ text: 'Monaco', code: 'MC' },
	{ text: 'Mongolie', code: 'MN' },
	{ text: 'Monténégro', code: 'ME' },
	{ text: 'Montserrat', code: 'MS' },
	{ text: 'Mozambique', code: 'MZ' },
	{ text: 'Birmanie', code: 'MM' },
	{ text: 'Namibie', code: 'NA' },
	{ text: 'Nauru', code: 'NR' },
	{ text: 'Népal', code: 'NP' },
	{ text: 'Nicaragua', code: 'NI' },
	{ text: 'Niger', code: 'NE' },
	{ text: 'Nigeria', code: 'NG' },
	{ text: 'Niue', code: 'NU' },
	{ text: 'Île Norfolk', code: 'NF' },
	{ text: 'Norvège', code: 'NO' },
	{ text: 'Nouvelle-Calédonie', code: 'NC' },
	{ text: 'Nouvelle-Zélande', code: 'NZ' },
	{ text: 'Territoire britannique de l\'océan Indien', code: 'IO' },
	{ text: 'Oman', code: 'OM' },
	{ text: 'Ouganda', code: 'UG' },
	{ text: 'Ouzbékistan', code: 'UZ' },
	{ text: 'Pakistan', code: 'PK' },
	{ text: 'Palaos', code: 'PW' },
	{ text: 'Palestine', code: 'PS' },
	{ text: 'Panama', code: 'PA' },
	{ text: 'Papouasie-Nouvelle-Guinée', code: 'PG' },
	{ text: 'Paraguay', code: 'PY' },
	{ text: 'Pays-Bas', code: 'NL' },
	{ text: 'Pérou', code: 'PE' },
	{ text: 'Philippines', code: 'PH' },
	{ text: 'Îles Pitcairn', code: 'PN' },
	{ text: 'Pologne', code: 'PL' },
	{ text: 'Polynésie française', code: 'PF' },
	{ text: 'Porto Rico', code: 'PR' },
	{ text: 'Portugal', code: 'PT' },
	{ text: 'Qatar', code: 'QA' },
	{ text: 'La Réunion', code: 'RE' },
	{ text: 'Roumanie', code: 'RO' },
	{ text: 'Royaume-Uni', code: 'GB' },
	{ text: 'Russie', code: 'RU' },
	{ text: 'Rwanda', code: 'RW' },
	{ text: 'République arabe sahraouie démocratique', code: 'EH' },
	{ text: 'Saint-Barthélemy', code: 'BL' },
	{ text: 'Saint-Christophe-et-Niévès', code: 'KN' },
	{ text: 'Saint-Marin', code: 'SM' },
	{ text: 'Saint-Martin', code: 'MF' },
	{ text: 'Saint-Martin', code: 'SX' },
	{ text: 'Saint-Pierre-et-Miquelon', code: 'PM' },
	{ text: 'Saint-Siège (État de la Cité du Vatican)', code: 'VA' },
	{ text: 'Saint-Vincent-et-les-Grenadines', code: 'VC' },
	{ text: 'Sainte-Hélène, Ascension et Tristan da Cunha', code: 'SH' },
	{ text: 'Sainte-Lucie', code: 'LC' },
	{ text: 'Salomon', code: 'SB' },
	{ text: 'Samoa', code: 'WS' },
	{ text: 'Samoa américaines', code: 'AS' },
	{ text: 'Sao Tomé-et-Principe', code: 'ST' },
	{ text: 'Sénégal', code: 'SN' },
	{ text: 'Serbie', code: 'RS' },
	{ text: 'Seychelles', code: 'SC' },
	{ text: 'Sierra Leone', code: 'SL' },
	{ text: 'Singapour', code: 'SG' },
	{ text: 'Slovaquie', code: 'SK' },
	{ text: 'Slovénie', code: 'SI' },
	{ text: 'Somalie', code: 'SO' },
	{ text: 'Soudan', code: 'SD' },
	{ text: 'Soudan du Sud', code: 'SS' },
	{ text: 'Sri Lanka', code: 'LK' },
	{ text: 'Suède', code: 'SE' },
	{ text: 'Suisse', code: 'CH' },
	{ text: 'Suriname', code: 'SR' },
	{ text: 'Svalbard et ile Jan Mayen', code: 'SJ' },
	{ text: 'Eswatini', code: 'SZ' },
	{ text: 'Syrie', code: 'SY' },
	{ text: 'Tadjikistan', code: 'TJ' },
	{ text: 'Taïwan / (République de Chine (Taïwan))', code: 'TW' },
	{ text: 'Tanzanie', code: 'TZ' },
	{ text: 'Tchad', code: 'TD' },
	{ text: 'Tchéquie', code: 'CZ' },
	{ text: 'Terres australes et antarctiques françaises', code: 'TF' },
	{ text: 'Thaïlande', code: 'TH' },
	{ text: 'Timor oriental', code: 'TL' },
	{ text: 'Togo', code: 'TG' },
	{ text: 'Tokelau', code: 'TK' },
	{ text: 'Tonga', code: 'TO' },
	{ text: 'Trinité-et-Tobago', code: 'TT' },
	{ text: 'Tunisie', code: 'TN' },
	{ text: 'Turkménistan', code: 'TM' },
	{ text: 'Îles Turques-et-Caïques', code: 'TC' },
	{ text: 'Turquie', code: 'TR' },
	{ text: 'Tuvalu', code: 'TV' },
	{ text: 'Ukraine', code: 'UA' },
	{ text: 'Uruguay', code: 'UY' },
	{ text: 'Vanuatu', code: 'VU' },
	{ text: 'Venezuela', code: 'VE' },
	{ text: 'Viêt Nam', code: 'VN' },
	{ text: 'Wallis-et-Futuna', code: 'WF' },
	{ text: 'Yémen', code: 'YE' },
	{ text: 'Zambie', code: 'ZM' },
	{ text: 'Zimbabwe', code: 'ZW' }
]

const languages = [
	{ code: 'af-ZA', text: 'Afrikaans (South Africa), Afrikaans (Suid-Afrika)' },
	{ code: 'am-ET', text: 'Amharic (Ethiopia)' },
	{ code: 'ar-DZ', text: 'Arabic (Algeria)' },
	{ code: 'ar-BH', text: 'Arabic (Bahrain)' },
	{ code: 'ar-EG', text: 'Arabic (Egypt)' },
	{ code: 'ar-IQ', text: 'Arabic (Iraq)' },
	{ code: 'ar-JO', text: 'Arabic (Jordan)' },
	{ code: 'ar-KW', text: 'Arabic (Kuwait)' },
	{ code: 'ar-LB', text: 'Arabic (Lebanon)' },
	{ code: 'ar-LY', text: 'Arabic (Libya)' },
	{ code: 'ar-MA', text: 'Arabic (Morocco)' },
	{ code: 'ar-OM', text: 'Arabic (Oman)' },
	{ code: 'ar-QA', text: 'Arabic (Qatar)' },
	{ code: 'ar-SA', text: 'Arabic (Saudi Arabia)' },
	{ code: 'ar-SY', text: 'Arabic (Syria)' },
	{ code: 'ar-TN', text: 'Arabic (Tunisia)' },
	{ code: 'ar-AE', text: 'Arabic (United Arab Emirates)' },
	{ code: 'ar-YE', text: 'Arabic (Yemen)' },
	{ code: 'az-AZ', text: 'Azerbaijani (Azerbaijan)' },
	{ code: 'be-BY', text: 'Belarusian (Belarus)' },
	{ code: 'bg-BG', text: 'Bulgarian (Bulgaria)' },
	{ code: 'bh-IN', text: 'Bihari (India)' },
	{ code: 'bi-VU', text: 'Bislama (Vanuatu)' },
	{ code: 'bn-BD', text: 'Bengali (Bangladesh)' },
	{ code: 'bn-IN', text: 'Bengali (India)' },
	{ code: 'ca-ES', text: 'Catalan (Spain)' },
	{ code: 'hr-HR', text: 'Croatian (Croatia), Hrvatski (Hrvatska)' },
	{ code: 'hy-AM', text: 'Armenian (Armenia)' },
	{ code: 'cs-CZ', text: 'Czech (Czech Republic)' },
	{ code: 'da-DK', text: 'Danish (Denmark), Dansk (Danmark)' },
	{ code: 'de-AT', text: 'German (Austria), Deutsch' },
	{ code: 'de-DE', text: 'German (Germany), Deutsch (Deutschland)' },
	{ code: 'de-LI', text: 'German (Liechtenstein), Deutsch (Liechtenstein)' },
	{ code: 'de-LU', text: 'German (Luxembourg), Deutsch (Luxemburg)' },
	{ code: 'de-CH', text: 'German (Switzerland), Deutsch (Schweiz)' },
	{ code: 'dv-MV', text: 'Divehi (Maldives)' },
	{ code: 'el-GR', text: 'Greek (Greece)' },
	{ code: 'en-AU', text: 'English (Australia)' },
	{ code: 'en-BZ', text: 'English (Belize)' },
	{ code: 'en-CA', text: 'English (Canada)' },
	{ code: 'en-IE', text: 'English (Ireland)' },
	{ code: 'en-IN', text: 'English (India)' },
	{ code: 'en-JM', text: 'English (Jamaica)' },
	{ code: 'en-NZ', text: 'English (New Zealand)' },
	{ code: 'en-PH', text: 'English (Philippines)' },
	{ code: 'en-ZA', text: 'English (South Africa)' },
	{ code: 'en-TT', text: 'English (Trinidad & Tobago)' },
	{ code: 'en-GB', text: 'English (UK)' },
	{ code: 'en-US', text: 'English (US)' },
	{ code: 'en-ZW', text: 'English (Zimbabwe)' },
	{ code: 'es-AR', text: 'Spanish (Argentina)' },
	{ code: 'es-BO', text: 'Spanish (Bolivia)' },
	{ code: 'es-CL', text: 'Spanish (Chile)' },
	{ code: 'es-CO', text: 'Spanish (Colombia)' },
	{ code: 'es-CR', text: 'Spanish (Costa Rica)' },
	{ code: 'es-DO', text: 'Spanish (Dominican Republic)' },
	{ code: 'es-EC', text: 'Spanish (Ecuador)' },
	{ code: 'es-ES', text: 'Spanish (Spain)' },
	{ code: 'es-GT', text: 'Spanish (Guatemala)' },
	{ code: 'es-HN', text: 'Spanish (Honduras)' },
	{ code: 'es-MX', text: 'Spanish (Mexico)' },
	{ code: 'es-NI', text: 'Spanish (Nicaragua)' },
	{ code: 'es-PA', text: 'Spanish (Panama)' },
	{ code: 'es-PE', text: 'Spanish (Peru)' },
	{ code: 'es-PR', text: 'Spanish (Puerto Rico)' },
	{ code: 'es-PY', text: 'Spanish (Paraguay)' },
	{ code: 'es-SV', text: 'Spanish (El Salvador)' },
	{ code: 'es-UY', text: 'Spanish (Uruguay)' },
	{ code: 'es-VE', text: 'Spanish (Venezuela)' },
	{ code: 'et-EE', text: 'Estonian (Estonia)' },
	{ code: 'eu-ES', text: 'Basque (Spain), Euskara (Espainia)' },
	{ code: 'fa-IR', text: 'Persian (Iran)' },
	{ code: 'fi-FI', text: 'Finnish (Finland), Suomi (Suomi)' },
	{ code: 'fo-FO', text: 'Faroese (Faroe Islands)' },
	{ code: 'fr-BE', text: 'French (Belgium)' },
	{ code: 'fr-CA', text: 'French (Canada)' },
	{ code: 'fr-CH', text: 'French (Switzerland)' },
	{ code: 'fr-FR', text: 'French (France)' },
	{ code: 'fr-LU', text: 'French (Luxembourg)' },
	{ code: 'fr-MC', text: 'French (Monaco)' },
	{ code: 'ga-IE', text: 'Irish (Ireland)' },
	{ code: 'gl-ES', text: 'Galician (Spain)' },
	{ code: 'gu-IN', text: 'Gujarati (India)' },
	{ code: 'he-IL', text: 'Hebrew (Israel)' },
	{ code: 'hi-JP', text: 'Hindi (Japan)' },
	{ code: 'hi-IN', text: 'Hindi (India)' },
	{ code: 'hu-HU', text: 'Hungarian (Hungary)' },
	{ code: 'id-ID', text: 'Indonesian (Indonesia)' },
	{ code: 'is-IS', text: 'Icelandic (Iceland)' },
	{ code: 'it-IT', text: 'Italian (Italy), Italiano (Italia)' },
	{ code: 'it-CH', text: 'Italian (Switzerland), Italiano (Svizzera)' },
	{ code: 'ja-JP', text: 'Japanese (Japan)' },
	{ code: 'ka-GE', text: 'Georgian (Georgia)' },
	{ code: 'kk-KZ', text: 'Kazakh (Kazakhstan)' },
	{ code: 'kn-IN', text: 'Kannada (India)' },
	{ code: 'km-KH', text: 'Khmer (Cambodia)' },
	{ code: 'ko-KR', text: 'Korean (South Korea)' },
	{ code: 'ky-KZ', text: 'Kyrgyz (Kazakhstan)' },
	{ code: 'lo-LA', text: 'Lao (Lao People\'s Democratic Republic)' },
	{ code: 'lb-LU', text: 'Luxembourgish (Luxembourg)' },
	{ code: 'lt-LT', text: 'Lithuanian (Lithuania)' },
	{ code: 'lv-LV', text: 'Latvian (Latvia)' },
	{ code: 'mh-MH', text: 'Marshallese (Marshall Islands)' },
	{ code: 'mk-MK', text: 'Macedonian (Macedonia)' },
	{ code: 'ml-IN', text: 'Malayalam (India)' },
	{ code: 'mn-MN', text: 'Mongolian (Mongolia)' },
	{ code: 'mr-IN', text: 'Marathi (India)' },
	{ code: 'ms-BN', text: 'Malay (Brunei), Bahasa Melayu (Brunei)' },
	{ code: 'ms-MY', text: 'Malay (Malaysia), Bahasa Melayu (Malaysia)' },
	{ code: 'mt-MT', text: 'Maltese (Malta), Malti (Malta)' },
	{ code: 'my-MM', text: 'Burmese (Myanmar)' },
	{ code: 'na-NR', text: 'Nauruan (Nauru), dorerin Naoero (Naoero)' },
	{ code: 'nb-NO', text: 'Norwegian Bokm (Norway), Norsk Bokm (Norge)' },
	{ code: 'ne-NP', text: 'Nepali (Nepal)' },
	{ code: 'nl-BE', text: 'Dutch (Belgium)' },
	{ code: 'nl-NL', text: 'Dutch (Netherlands), Nederlands (Nederland)' },
	{ code: 'nn-NO', text: 'Norwegian Nynorsk (Norway), Nynorsk (Noreg)' },
	{ code: 'or-IN', text: 'Oriya (India)' },
	{ code: 'pa-IN', text: 'Punjabi (India)' },
	{ code: 'pa-PK', text: 'Punjabi (Pakistan)' },
	{ code: 'pl-PL', text: 'Polish (Poland), Polski (Polska)' },
	{ code: 'pt-BR', text: 'Portuguese (Brazil)' },
	{ code: 'pt-PT', text: 'Portuguese (Portugal)' },
	{ code: 'ro-RO', text: 'Romanian (Romania)' },
	{ code: 'rw-RW', text: 'Kinyarwanda (Rwanda), Kinyarwanda (U Rwanda)' },
	{ code: 'ru-RU', text: 'Russian (Russia)' },
	{ code: 'sa-IN', text: 'Sanskrit (India)' },
	{ code: 'si-LK', text: 'Sinhala (Sri Lanka)' },
	{ code: 'sk-SK', text: 'Slovak (Slovakia), Sloven (Slovensko)' },
	{ code: 'sl-SI', text: 'Slovenian (Slovenia), Sloven (Slovenija)' },
	{ code: 'sm-WS', text: 'Samoan (Samoa), Samoa (Samoa)' },
	{ code: 'sn-ZW', text: 'Shona (Zimbabwe)' },
	{ code: 'so-SO', text: 'Somali (Somalia), Somali (Soomaaliya)' },
	{ code: 'sq-AL', text: 'Albanian (Albania)' },
	{ code: 'sr-RS', text: 'Serbian (Serbia)' },
	{ code: 'sw-KE', text: 'Swahili (Kenya), Kiswahili (Kenya)' },
	{ code: 'sv-FI', text: 'Swedish (Finland), Svenska (Finland)' },
	{ code: 'sv-SE', text: 'Swedish (Sweden), Svenska (Sverige)' },
	{ code: 'syr-SY', text: 'Syriac (Syria)' },
	{ code: 'ta-IN', text: 'Tamil (India)' },
	{ code: 'te-IN', text: 'Telugu (India)' },
	{ code: 'ti-ER', text: 'Tigrinya (Eritrea)' },
	{ code: 'tg-TJ', text: 'Tajik (Tajikistan)' },
	{ code: 'th-TH', text: 'Thai (Thailand)' },
	{ code: 'tk-TM', text: 'Turkmen (Turkmenistan)' },
	{ code: 'tr-TR', text: 'Turkish (Turkey)' },
	{ code: 'tt-RU', text: 'Tatar (Russia)' },
	{ code: 'uk-UA', text: 'Ukrainian (Ukraine)' },
	{ code: 'ur-PK', text: 'Urdu (Pakistan)' },
	{ code: 'uz-UZ', text: 'Uzbek (Uzbekistan)' },
	{ code: 'vi-VN', text: 'Vietnamese (Vietnam)' },
	{ code: 'fil-PH', text: 'Filipino (Philippines), Filipino (Pilipinas)' },
	{ code: 'kok-in', text: 'Konkani (India)' },
	{ code: 'mni-in', text: 'Manipuri (India)' },
	{ code: 'sdp-IN', text: 'Sherdukpen (India), Mey nyuk (India)' },
	{ code: 'es-419', text: 'Spanish (Latin America)' },
	{ code: 'zh-Hans', text: 'Chinese (Simplified) -- timed text only' },
	{ code: 'zh-Hant', text: 'Chinese (Traditional) -- timed text only' },
	{ code: 'zh-CN', text: 'Chinese (Simplified) -- metadata only' },
	{ code: 'zh-TW', text: 'Chinese (Traditional) -- metadata only' },
	{ code: 'cmn-CN', text: 'Mandarin (Mainland China accent) -- video/audio only' },
	{ code: 'cmn-TW', text: 'Mandarin (Taiwanese accent) -- video/audio only' },
	{ code: 'yue', text: 'Cantonese -- video/audio only' }
]

const languages_lang = [
	{ code: 'af', text: 'Afrikaans' },
	{ code: 'am', text: 'Amharic' },
	{ code: 'ar', text: 'Arabic' },
	{ code: 'az', text: 'Azerbaijani' },
	{ code: 'be', text: 'Belarusi' },
	{ code: 'bg', text: 'Bulgari' },
	{ code: 'bh', text: 'Biha' },
	{ code: 'bi', text: 'Bisla' },
	{ code: 'bn', text: 'Benga' },
	{ code: 'ca', text: 'Catal' },
	{ code: 'hr', text: 'Croatian' },
	{ code: 'hy', text: 'Armenian' },
	{ code: 'cs', text: 'Czech' },
	{ code: 'da', text: 'Danish' },
	{ code: 'de', text: 'German' },
	{ code: 'dv', text: 'Divehi' },
	{ code: 'el', text: 'Greek' },
	{ code: 'en', text: 'English' },
	{ code: 'es', text: 'Spanish' },
	{ code: 'et', text: 'Estonian' },
	{ code: 'eu', text: 'Basque' },
	{ code: 'fa', text: 'Persian' },
	{ code: 'fi', text: 'Finnish' },
	{ code: 'fo', text: 'Faroese' },
	{ code: 'fr', text: 'French' },
	{ code: 'ga', text: 'Irish' },
	{ code: 'gl', text: 'Galician' },
	{ code: 'gu', text: 'Gujarati' },
	{ code: 'he', text: 'Hebrew' },
	{ code: 'hi', text: 'Hindi' },
	{ code: 'hu', text: 'Hungarian' },
	{ code: 'id', text: 'Indonesian' },
	{ code: 'is', text: 'Icelandic' },
	{ code: 'it', text: 'Italian' },
	{ code: 'ja', text: 'Japanese' },
	{ code: 'ka', text: 'Georgian' },
	{ code: 'kk', text: 'Kazakh' },
	{ code: 'kn', text: 'Kannada' },
	{ code: 'km', text: 'Khmer' },
	{ code: 'ko', text: 'Korean' },
	{ code: 'ky', text: 'Kyrgyz' },
	{ code: 'lo', text: 'Lao' },
	{ code: 'lb', text: 'Luxembourgish' },
	{ code: 'lt', text: 'Lithuanian' },
	{ code: 'lv', text: 'Latvian' },
	{ code: 'mh', text: 'Marshallese' },
	{ code: 'mk', text: 'Macedonian' },
	{ code: 'ml', text: 'Malayalam' },
	{ code: 'mn', text: 'Mongolian' },
	{ code: 'mr', text: 'Marathi' },
	{ code: 'ms', text: 'Malay' },
	{ code: 'mt', text: 'Maltese' },
	{ code: 'my', text: 'Burmese' },
	{ code: 'na', text: 'Nauruan' },
	{ code: 'nb', text: 'Norwegian Bokm' },
	{ code: 'ne', text: 'Nepali' },
	{ code: 'nl', text: 'Dutch' },
	{ code: 'nn', text: 'Norwegian Nynorsk' },
	{ code: 'or', text: 'Oriya' },
	{ code: 'pa', text: 'Punjabi' },
	{ code: 'pl', text: 'Polish' },
	{ code: 'pt', text: 'Portuguese' },
	{ code: 'ro', text: 'Romanian' },
	{ code: 'rw', text: 'Kinyarwanda' },
	{ code: 'ru', text: 'Russian' },
	{ code: 'sa', text: 'Sanskrit' },
	{ code: 'si', text: 'Sinhala' },
	{ code: 'sk', text: 'Slovak' },
	{ code: 'sl', text: 'Slovenian' },
	{ code: 'sm', text: 'Samoan' },
	{ code: 'sn', text: 'Shona' },
	{ code: 'so', text: 'Somali' },
	{ code: 'sq', text: 'Albanian' },
	{ code: 'sr', text: 'Serbian' },
	{ code: 'sw', text: 'Swahili' },
	{ code: 'sv', text: 'Swedish' },
	{ code: 'syr', text: 'Syriac' },
	{ code: 'ta', text: 'Tamil' },
	{ code: 'te', text: 'Telugu' },
	{ code: 'ti', text: 'Tigrinya' },
	{ code: 'tg', text: 'Tajik' },
	{ code: 'th', text: 'Thai' },
	{ code: 'tk', text: 'Turkmen' },
	{ code: 'tr', text: 'Turkish' },
	{ code: 'tt', text: 'Tatar' },
	{ code: 'uk', text: 'Ukrainian' },
	{ code: 'ur', text: 'Urdu' },
	{ code: 'uz', text: 'Uzbek' },
	{ code: 'vi', text: 'Vietnamese' },
	{ code: 'fil', text: 'Filipino' },
	{ code: 'kok', text: 'Konkani' },
	{ code: 'mni', text: 'Manipuri' },
	{ code: 'sdp', text: 'Sherdukpen' },
	{ code: 'es', text: 'Spanish' },
	{ code: 'zh', text: 'Chinese' },
	{ code: 'cmn', text: 'Mandarin' },
	{ code: 'yue', text: 'Cantonese' }
]

const suifa_langue_id_to_xbox_language = {
	1: 'fr-FR',
	2: 'en-US',
	3: 'es-ES',
	4: 'de-DE',
	5: 'it-IT',
	6: '', // APA Apache
	7: '', // ANT Antillais
	8: 'tr-TR',
	9: 'zh-TW',
	10: 'th-TH',
	11: 'ar-MA',
	12: 'pt-PT',
	13: '', // COS Corse
	14: '', // AFR Africain
	15: 'sq-AL',
	16: 'ar-DZ',
	17: '', // ARA Arabe
	18: 'es-AR',
	19: 'hy-AM',
	20: 'id-ID',
	21: '', // BAN Banbara
	22: '', // BAO Baoules
	23: 'eu-ES',
	24: 'bn-BD',
	25: 'es-BO',
	26: '', // BOS Bosniaque
	27: 'pt-BR',
	28: 'bg-BG',
	29: 'my-MM',
	30: 'km-KH',
	31: 'yue',
	32: 'es-ES',
	33: 'ca-ES',
	34: 'ko-KR',
	35: '', // CRE Creole
	36: 'hr-HR',
	37: 'da-DK',
	38: '', // EFF Effets/Bruits
	39: 'ar-EG',
	40: 'et-EE',
	41: 'fa-IR',
	42: 'fi-FI',
	43: 'fi-FI',
	44: 'nl-BE',
	45: 'ga-IE',
	46: 'ka-GE',
	47: '', // GIT Gitan
	48: 'el-GR',
	49: 'he-IL',
	50: 'nl-NL',
	51: 'hu-HU',
	52: 'id-ID',
	53: '', // International m&e
	54: 'fa-IR',
	55: 'he-IL',
	56: 'ja-JP',
	57: 'km-KH',
	58: '', // KUR Kurde
	59: '', // LAT Latin
	60: 'lv-LV',
	61: 'ar-LB',
	62: 'lt-LT',
	63: 'fr-LU',
	64: 'mk-MK',
	65: '', // MAL Malgache
	66: '', // MAI Malien
	67: 'cmn-CN',
	68: '', // MAO Maori
	69: 'es-MX',
	70: 'mn-MN',
	71: 'nl-NL',
	72: 'nb-NO',
	73: 'ur-PK',
	74: '', // PAP Papou
	75: '', // PAT Patois
	76: 'fa-IR',
	77: '', // PIT Pitchin
	78: 'pl-PL',
	79: 'ro-RO',
	80: 'ru-RU',
	81: '', // SEN Senegalais
	82: 'sr-RS',
	83: '', // SIO Sioux
	84: '', // SLA Slave
	85: 'sk-SK',
	86: 'sv-SE',
	87: 'cs-CZ',
	88: '', // TIB Tibetain
	89: 'ar-TN',
	90: 'uk-UA',
	91: 'vi-VN',
	92: '', // WOL Wolof
	93: '', // YID Yidish
	94: '', // YOU Yougoslave
	95: '', // ZAI Zairois
	96: '', // ZOU Zoulou
	97: '', // MUE Muet
	98: '', // MUS Musique
	99: '', // LTC ltc
	100: '', // ORI Originale
	101: '', // ? Langue indeterminee
	102: '', // DIA Dialoque
	103: 'fr-CA',
	104: 'en-IE',
	105: 'is-IS',
	106: '', // KIR Kirundi
	107: '', // BRT Breton
	108: '', // TOU Touareg
	109: 'cmn-TW',
	110: '', // TCA Tchadien
	111: 'en-AU',
	112: '', // DLC Dialecte
	113: 'es-PE',
	114: '', // MAG Magrebin
	115: '', // RIR Rires
	116: '', // BER Berbere
	117: '', // TAH Tahitien
	118: '', // CUB Cubain
	119: '', // NON Efface
	120: '', // MUL Multilingue
	121: '', // AUD Audio commentaires
	122: '', // ORISC Originale sans commentaire
	123: '', // DAR Dari
	124: '', // ABS Absence de generique
	125: '', // SAN sans
	126: '', // FRM Francais malentendant
	127: '', // TEM Temoin
	128: 'hi-IN',
	129: 'fil-PH',
	130: '', // DIR Direct son
	131: 'zh-CN',
	132: '', // INTR Inter rajout
	133: '', // AMB Ambiance
	134: 'sl-SI',
	135: 'de-AT',
	136: '', // ADE Audio description
	137: '', // TAM Tamoul
	138: '', // KAN Kanada
	139: 'ur-PK',
	140: '', // M&E m&e
	141: '', // ANGM Anglais Malentendant
	142: '', // FRS Francais s&m simplifié
	143: '', // DIAG Dialoque guide
	144: '', // OPT Option stems
	145: '', // DME DME
	146: '', // STEMS Fichier stems
	147: 'es-419'
}

const ratings = {
	'Argentina [AR]': {
		country: 'AR',
		systems: {
			'INCAA': {
				type: ['Film', 'Trailer'],
				ratings: ['ATP', 'SAM13', 'SAM16', 'SAM18', 'C']
			}
		}
	},
	'Australia [AU]': {
		country: 'AU',
		systems: {
			'NCS': {
				type: ['Film'],
				ratings: ['G', 'PG', 'M', 'MA15', 'R18+', 'CTC', 'X18+', 'RC']
			},
			'ACMA': {
				type: ['TV'],
				ratings: ['P', 'C']
			}
		}
	},
	'Austria [AT]': {
		country: 'AT',
		systems: {
			'BMUKK': {
				type: ['Film'],
				ratings: ['AA', '6', '8', '10', '12', '14', '16']
			}
		}
	},
	'Belgium [BE]': {
		country: 'BE',
		systems: {
			'CICF': {
				type: ['Film'],
				ratings: ['E', 'KT/EA', 'KNT/ENA']
			}
		}
	},
	'Brazil [BR]': {
		country: 'BR',
		systems: {
			'DJCTQ': {
				type: ['Film', 'TV'],
				ratings: ['ER', 'L-12', 'L-14', 'L-16', 'L-18', 'L-10', 'L', '10-18', '10-16', '10-14', '10-12', '10', '12-16', '12-14', '12', '12-18', '14-16', '14', '14-18', '16-18', '16', '18']
			}
		}
	},
	'Bulgaria [BG]': {
		country: 'BG',
		systems: {
			'NFRC': {
				type: ['Film'],
				ratings: ['A', 'B', 'C', 'D', 'X']
			}
		}
	},
	'Canada [CA]': {
		country: 'CA',
		systems: {
			'AFC': {
				type: ['Film'],
				ratings: ['G', 'PG', '14A', '18A', 'R']
			},
			'CBSC': {
				type: ['TV'],
				ratings: ['C', 'E', 'C8', 'G', 'PG', '14', '18']
			},
			'CBSC-F': {
				type: ['Film', 'TV'],
				ratings: ['G', '8+', '13+', '16+', '18+', 'RC', '']
			},
			'CHVRS': {
				type: ['Film'],
				ratings: ['G', 'E', 'PG', '14A', '18A', 'R']
			},
			'CPBC': {
				type: ['Film'],
				ratings: ['G', 'PG', '14A', '18A', 'R', 'A']
			},
			'CPBC-T': {
				type: ['Trailer'],
				ratings: ['AP', 'SP', 'A']
			},
			'MFCB': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G', 'PG', '14A', '18A', 'R', 'A']
			},
			'OFRB': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G', 'PG', '14A', '18A', 'R']
			},
			'RCQ': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G', '13+', '16+', '18+', 'RC']
			}
		}
	},
	'Chile [CL]': {
		country: 'CL',
		systems: {
			'CCC': {
				type: ['Film'],
				ratings: ['TE', '6', '14', '18', '18V', '18S']
			},
			'ANATEL': {
				type: ['TV'],
				ratings: ['F', 'I', 'I-7', 'I-10', 'I-12', 'R', 'A']
			}
		}
	},
	'Colombia [CO]': {
		country: 'CO',
		systems: {
			'MOC': {
				type: ['Film'],
				ratings: ['E', 'T', '7', '12', '15', '18', 'X', 'Banned']
			}
		}
	},
	'Czech Republic [CZ]': {
		country: 'CZ',
		systems: {
			'Film': {
				type: ['Film', 'Trailer'],
				ratings: ['U', '12', '14', '18']
			}
		}
	},
	'Germany [DE]': {
		country: 'DE',
		systems: {
			'FSK': {
				type: ['Film', 'TV'],
				ratings: ['0', '6', '12', '16', '18', 'SPIO/JK', 'NR', 'TBC']
			}
		}
	},
	'Denmark [DK]': {
		country: 'DK',
		systems: {
			'MCCYP': {
				type: ['Film'],
				ratings: ['A', '7', '11', '15']
			}
		}
	},
	'Egypt [EG]': {
		country: 'EG',
		systems: {
			'Film': {
				type: ['Film', 'Trailer'],
				ratings: ['GN', '18', 'BN']
			}
		}
	},
	'Estonia [EE]': {
		country: 'EE',
		systems: {
			'Film': {
				type: ['Film', 'Trailer'],
				ratings: ['Pere', 'L', 'MS-6', 'K-6', 'MS-12', 'K-12', 'K-14', 'K-16']
			}
		}
	},
	'Finland [FI]': {
		country: 'FI',
		systems: {
			'MEKU': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['S', '7', '12', '16', '18']
			}
		}
	},
	'France [FR]': {
		country: 'FR',
		systems: {
			'CSA': {
				type: ['TV'],
				ratings: ['10', '12', '16', '18', 'interdiction']
			},
			'CNC': {
				type: ['Film', 'Trailer'],
				ratings: ['T', '12', '16', '18', 'interdiction']
			}
		}
	},
	'Greece [GR]': {
		country: 'GR',
		systems: {
			'Film': {
				type: ['Film', 'Trailer'],
				ratings: ['K', 'E', 'K-13', 'K-17']
			}
		}
	},
	'Global': {
		country: '',
		systems: {
			'UNRATED': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['ALL', 'UNRATED', 'ADULT', 'PROSCRIBED']
			}
		}
	},
	'Hong Kong [HK]': {
		country: 'HK',
		systems: {
			'FCO': {
				type: ['Film'],
				ratings: ['I', 'IIA', 'IIB', 'III']
			}
		}
	},
	'Hungary [HU]': {
		country: 'HU',
		systems: {
			'RCNOF': {
				type: ['Film'],
				ratings: ['I', 'II', 'III', 'IV', 'V', 'VI']
			}
		}
	},
	'Iceland [IS]': {
		country: 'IS',
		systems: {
			'SMAIS': {
				type: ['Film', 'Trailer'],
				ratings: ['L', '7', '12', '14', '16', '18']
			},
			'Kijkwijzer': {
				type: ['Film'],
				ratings: ['AL', '6', '9', '12', '16']
			}
		}
	},
	'India [IN]': {
		country: 'IN',
		systems: {
			'CBFC': {
				type: ['Film'],
				ratings: ['U', 'UA', 'A', 'S']
			}
		}
	},
	'Indonesia [ID]': {
		country: 'ID',
		systems: {
			'LSF': {
				type: ['Film', 'Trailer'],
				ratings: ['SU', 'A', '13', '17', '21']
			}
		}
	},
	'Ireland [IE]': {
		country: 'IE',
		systems: {
			'RTE': {
				type: ['TV'],
				ratings: ['GA', 'Ch', 'PS', 'MA']
			},
			'IFCOF': {
				type: ['Film', 'TV'],
				ratings: ['G', 'PG', '12A', '15A', '16', '18']
			}
		}
	},
	'Israel [IL]': {
		country: 'IL',
		systems: {
			'Film': {
				type: ['Film', 'TV'],
				ratings: ['ALL', '12', '14', '16', '18']
			}
		}
	},
	'Italy [IT]': {
		country: 'IT',
		systems: {
			'MBACT': {
				type: ['Film'],
				ratings: ['T', 'VM14', 'VM18']
			},
			'AGCOM': {
				type: ['TV'],
				ratings: ['T', 'VM14', 'VM18']
			}
		}
	},
	'Japan [JP]': {
		country: 'JP',
		systems: {
			'Eirin': {
				type: ['Film', 'TV'],
				ratings: ['G', 'PG-12', 'R15+', 'R18+', 'NR', 'TBC']
			}
		}
	},
	'Kenya [KE]': {
		country: 'KE',
		systems: {
			'KFCB': {
				type: ['Film', 'Trailer'],
				ratings: ['G', 'PG', '16+', 'R']
			}
		}
	},
	'Korea, Rep. [KR]': {
		country: 'KR',
		systems: {
			'KMRB': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G', '12+', '15+', '18+', 'LIM']
			}
		}
	},
	'Latvia [LV]': {
		country: 'LV',
		systems: {
			'NKC-LV': {
				type: ['Film', 'TV'],
				ratings: ['U', '7+', '12+', '16+', '18+']
			}
		}
	},
	'Luxembourg [LU]': {
		country: 'LU',
		systems: {
			'CSCF': {
				type: ['Film'],
				ratings: ['A', '6', '12', '16', '18']
			}
		}
	},
	'Malaysia [MY]': {
		country: 'MY',
		systems: {
			'FCBM': {
				type: ['Film'],
				ratings: ['U', 'P13', '18', '18SX', '18PA', '18SG', '18PL']
			}
		}
	},
	'Maldives [MV]': {
		country: 'MV',
		systems: {
			'NBC': {
				type: ['Film'],
				ratings: ['G', 'PG', '12+', '15+', '18+', '18+R', 'PU']
			}
		}
	},
	'Malta [MT]': {
		country: 'MT',
		systems: {
			'MCCAA': {
				type: ['Film'],
				ratings: ['U', 'PG', '12A', '12', '14', '15', '16', '18']
			}
		}
	},
	'Mexico [MX]': {
		country: 'MX',
		systems: {
			'RTC': {
				type: ['Film'],
				ratings: ['AA', 'A', 'B', 'B15', 'D', 'C']
			}
		}
	},
	'Netherlands [NL]': {
		country: 'NL',
		systems: {
			'Kijkwijzer': {
				type: ['Film', 'TV'],
				ratings: ['AL', '6', '9', '12', '16']
			}
		}
	},
	'New Zealand [NZ]': {
		country: 'NZ',
		systems: {
			'OFLC': {
				type: ['Film'],
				ratings: ['G', 'PG', 'RP13', 'R13', 'R15', 'M', 'RP16', 'R16', 'R18', 'R']
			}
		}
	},
	'Nigeria [NG]': {
		country: 'NG',
		systems: {
			'NFVCB': {
				type: ['Film'],
				ratings: ['G', 'PG', '12', '12A', '15', '18', 'RE']
			}
		}
	},
	'Norway [NO]': {
		country: 'NO',
		systems: {
			'Medietilsynet': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['A', '6', '9', '7', '11', '12', '15', '18']
			}
		}
	},
	'Peru [PE]': {
		country: 'PE',
		systems: {
			'Film': {
				type: ['Film'],
				ratings: ['PT', 'PG', '14', '18']
			}
		}
	},
	'Philippines [PH]': {
		country: 'PH',
		systems: {
			'MTRCB': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G-TV', 'G', 'PG-TV', 'PG', 'SPG', 'R13', 'R16', 'R18', 'X']
			}
		}
	},
	'Poland [PL]': {
		country: 'PL',
		systems: {
			'NBC-PL': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['I', 'II', 'III', 'IV', '18+']
			}
		}
	},
	'Portugal [PT]': {
		country: 'PT',
		systems: {
			'CCE': {
				type: ['Film', 'Trailer'],
				ratings: ['M/4', 'M/6', 'M/12', 'M/16', 'M/18']
			}
		}
	},
	'Romania [RO]': {
		country: 'RO',
		systems: {
			'CNA': {
				type: ['Film', 'Trailer'],
				ratings: ['AP', '12', '15', '18', '18+']
			}
		}
	},
	'Russia [RU]': {
		country: 'RU',
		systems: {
			'MKRF': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['0', '6', '12', '16', '18']
			}
		}
	},
	'Singapore [SG]': {
		country: 'SG',
		systems: {
			'MDA': {
				type: ['Film', 'Trailer'],
				ratings: ['G', 'PG', 'PG13', 'NC16', 'M18', 'R21']
			}
		}
	},
	'Slovakia [SK]': {
		country: 'SK',
		systems: {
			'Film': {
				type: ['Film', 'Trailer'],
				ratings: ['G', 'P2', 'P5', 'P8']
			}
		}
	},
	'South Africa [ZA]': {
		country: 'ZA',
		systems: {
			'FPB': {
				type: ['Film', 'TV'],
				ratings: ['A', 'PG', '7-9-PG', '10', '10-12-PG', '13', '16', '18', 'X18', 'XX']
			}
		}
	},
	'Spain [ES]': {
		country: 'ES',
		systems: {
			'ICAA': {
				type: ['Film', 'Trailer'],
				ratings: ['APTA', 'ER', '7', '12', '13', '16', '18', 'X']
			}
		}
	},
	'Sweden [SE]': {
		country: 'SE',
		systems: {
			'SM-SA': {
				type: ['Film', 'Trailer'],
				ratings: ['Barntillåten', '7', '11', '15']
			}
		}
	},
	'Switzerland [CH]': {
		country: 'CH',
		systems: {
			'Film': {
				type: ['Film', 'TV'],
				ratings: ['0', '6', '12', '16', '18']
			}
		}
	},
	'Taiwan [TW]': {
		country: 'TW',
		systems: {
			'MOC-TW': {
				type: ['Film', 'Trailer'],
				ratings: ['G', 'P', 'PG', 'R']
			}
		}
	},
	'Thailand [TH]': {
		country: 'TH',
		systems: {
			'BFVC': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['G', 'E', '13', '15', '18', '20', 'B']
			}
		}
	},
	'Turkey [TR]': {
		country: 'TR',
		systems: {
			'IBMCT': {
				type: ['Film'],
				ratings: ['GA', '7A', '7', '13A', '13', '15A', '15', '18']
			}
		}
	},
	'Ukraine [UA]': {
		country: 'UA',
		systems: {
			'Ukraine': {
				type: ['Film', 'Trailer', 'TV'],
				ratings: ['Yes', 'For', '14', '16', '18', 'X21', 'Denied']
			}
		}
	},
	'United Kingdom [UK]': {
		country: 'UK',
		systems: {
			'BBFC': {
				type: ['Film', 'TV'],
				ratings: ['U', 'PG', '12', '15', '18', 'NR', 'TBC']
			}
		}
	},
	'United States [US]': {
		country: 'US',
		systems: {
			'MPAA': {
				type: ['Film'],
				ratings: ['G', 'PG', 'PG-13', 'R', 'NC-17', 'NR', 'TBC']
			},
			'TVPG': {
				type: ['TV'],
				ratings: ['TV-Y', 'TV-Y7', 'TV-Y7-FV', 'TV-G', 'TV-PG', 'TV-14', 'TV-MA', 'NR', 'TBC']
			}
		}
	},
	'Venezuela [VE]': {
		country: 'VE',
		systems: {
			'RESORTE-Health': {
				type: ['Film', 'TV'],
				ratings: ['A', 'B', 'C', 'D']
			},
			'RESORTE-Sexo': {
				type: ['Film', 'TV'],
				ratings: ['A', 'B', 'C', 'D', 'E']
			},
			'RESORTE-Language': {
				type: ['Film', 'TV'],
				ratings: ['A', 'B', 'C']
			},
			'RESORTE-Violencia': {
				type: ['Film', 'TV'],
				ratings: ['A', 'B', 'C', 'D', 'E']
			}
		}
	},
	'Viet Nam [VN]': {
		country: 'VN',
		systems: {
			'MCST': {
				type: ['Film', 'TV'],
				ratings: ['0', 'P', 'C13', 'C16', '16+', 'C18', 'NYR']
			}
		}
	}
}

const job_functions = [
	'Actor',
	'Director',
	'Producer',
	'Writer'
]

const video_types = [
	'feature',
	'dubcard',
	'trailer',
	'preview'
]

const subtitle_types = [
	'SDH',
	'normal',
	'forced'
]

const package_types = [
	'tv',
	'movie'
]

module.exports = {
	asset_types,
	asset_roles,
	package_types,
	audio_types,
	subtitle_types,
	ReleaseType,
	PictureColorType,
	genres,
	countries,
	languages,
	languages_lang,
	suifa_langue_id_to_xbox_language,
	ratings,
	job_functions,
	video_types
}



// WEBPACK FOOTER //
// ./src/pages/packages/xbox/packager_xbox_enums.js